module.exports = __webpack_public_path__ + "d4b3ddfb6924e6db7221d14c91c9ebfb.svg";